import {LOCALE_ID, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule, DatePipe, registerLocaleData} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AuthGuard} from './guard/auth.guard';
import {AuthInterceptor} from './interceptor/auth.interceptor';
import {MainInterceptor} from './main.interceptor';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {getDutchPaginatorIntl} from './french-paginator-intl';
import {JwtModule} from '@auth0/angular-jwt';
import localeFr from '@angular/common/locales/fr';
import {NotificationModule} from './notification/notification.module';
import {DeleteComponent} from './shared/delete/delete.component';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {CustomTitleStrategy} from './constant/custom-title-strategy';
import {TitleStrategy} from '@angular/router';
import {DateAdapter, NativeDateAdapter} from '@angular/material/core';

registerLocaleData(localeFr);

export function tokenGetter() {
  return localStorage.getItem("token");
}

@NgModule({
  declarations: [
    AppComponent,
    DeleteComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CommonModule,
    NotificationModule,
    AppRoutingModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [],
        disallowedRoutes: [],
      },
    }),
    MatButtonModule, MatDialogModule

  ],
  providers: [
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MainInterceptor,
      multi: true
    },
    {
      provide: MatPaginatorIntl,
      useValue: getDutchPaginatorIntl()
    },
    {provide: LOCALE_ID, useValue: 'fr'},
    {provide: DateAdapter, useClass: NativeDateAdapter},
    {provide: TitleStrategy, useClass: CustomTitleStrategy},
    DatePipe

  ],
  bootstrap: [AppComponent]

})
export class AppModule {
  constructor() {
  }
}
